import { ChartSize } from '../../types';
import { PieChartDimensions } from './types';

export const sizeToDimension = (size: ChartSize | PieChartDimensions, isHalf?: boolean): PieChartDimensions => {
  if (typeof size !== 'string') {
    return size;
  }

  switch (size) {
    case ChartSize.small:
      return {
        width: 200,
        height: 200 * (isHalf ? 0.5 : 1),
        smallFontSize: 13,
        fontSize: 30,
        innerRadius: 55,
      };
    case ChartSize.large:
      return {
        width: 300,
        height: 300 * (isHalf ? 0.5 : 1),
        smallFontSize: 18,
        fontSize: 38,
        innerRadius: 80,
      };
    case ChartSize.medium:
    default:
      return {
        width: 240,
        height: 240 * (isHalf ? 0.5 : 1),
        smallFontSize: 14,
        fontSize: 34,
        innerRadius: 65,
      };
  }
};
